module.exports = require('./lib');



// WEBPACK FOOTER //
// ../node_modules/deepcopy/index.js